import { Suspense, lazy } from 'react';
import { LoadingOverlay } from '@/components/common/LoadingOverlay';

const LazyDesignLayers = lazy(
  () => import(/* webpackChunkName: 'design-layers' */ './DesignLayers')
);

export const AsyncDesignLayers = () => (
  <Suspense fallback={<LoadingOverlay />}>
    <LazyDesignLayers />
  </Suspense>
);
